// import React from 'react';
import { projects } from '../data/projects';
import { Project } from '../types/project';
import ProjectTile from './ProjectTile';

const ThinkingPage: React.FC = () => {
  const thinkingProjects = projects.filter(p => p.category === 'thinking');

  return (
    <div>
      <h2>Tools</h2>
      <div className="project-list">
        {thinkingProjects.length > 0 ? (
          thinkingProjects.map((project: Project) => (
            <ProjectTile key={project.id} project={project} />
          ))
        ) : (
          <p>No tools yet!</p>
        )}
      </div>
    </div>
  );
};

export default ThinkingPage;
